class DraggableHelper {
  dragElement(element: HTMLElement) {
    let elementPosition01 = 0;
    let elementPosition02 = 0;
    let elementPosition03 = 0;
    let elementPosition04 = 0;

    const closeDragElement = () => {
      document.onmouseup = null;
      document.onmousemove = null;
    };

    const elementDrag = (event: Event) => {
      event.preventDefault();

      elementPosition01 = elementPosition03 - event.clientX;
      elementPosition02 = elementPosition04 - event.clientY;
      elementPosition03 = event.clientX;
      elementPosition04 = event.clientY;

      element.style.top = `${element.offsetTop - elementPosition02}px`;
      element.style.left = `${element.offsetLeft - elementPosition01}px`;
    };

    const dragMouseDown = (event: Event) => {
      if (event.target.tagName !== 'INPUT') {
        event.preventDefault();

        elementPosition03 = event.clientX;
        elementPosition04 = event.clientY;

        document.onmouseup = closeDragElement;
        document.onmousemove = elementDrag;
      }
    };

    element.onmousedown = dragMouseDown;
  }
}

export default new DraggableHelper();
